import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { BankPortalService, PosHistoryViewModel } from "../../../web-api-client";

import * as moment from 'moment';

import "ag-grid-angular";
import 'ag-grid-community/dist/styles/ag-grid.css';
import { ActivatedRoute } from '@angular/router';
import * as _ from "lodash";
import { PosHistory } from "../../../core/models/posHistory/pos-history.model";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: 'accessories-request-details',
  templateUrl: './accessories-request-details.component.html',
})
export class AccessoriesRequestDetailsComponent implements OnInit {
 loadingIndicator!: boolean;
  columnDefs: any[] = [];
  columns: any[] = [];
  public gridApi;
  public gridColumnApi;
  public defaultColDef;
  public popupParent;
  rows2: PosHistory[] = [];
  rowsCache: PosHistory[] = [];
  rows: any;


  constructor(private _toastr: ToastrService, 
    private _route: ActivatedRoute, 
    private bankportalservice: BankPortalService) {
  }

  ngOnInit() {



    this.columnDefs = [
            { headerName: 'Accessory Type', field: 'terminalType', width: 300, suppressSizeToFit: true },
            { headerName: 'Requested Qty', field: 'requested_Quantity', width: 200, suppressSizeToFit: true },
            { headerName: 'Delivered Qty', field: 'dispatch_Quantity', width: 200, suppressSizeToFit: true },
            { headerName: 'Requested Location', field: 'location', width: 180, suppressSizeToFit: true },
            { headerName: 'Status', field: 'spareRequestStatusValue', width: 150, suppressSizeToFit: true,cellRenderer :this.SpareRequestStatus },
            { headerName: 'Requested Date', field: 'requested_Date', valueFormatter: (data) => moment(data.value).format('ll'), width: 150, suppressSizeToFit: true },
            { headerName: 'Delivered Date', field: 'dispatch_Date', width: 150, suppressSizeToFit: true,},

    ];
    this.loadAccesoriesRequestDetails();
    

  }


  onBtnExport() {
    this.gridApi.exportDataAsCsv();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

  }


  onSearchChanged(value: string) {
    // this.rows2 = this.rowsCache.filter(r => Utilities.searchArray(value, false, r.merchant, r.idMerchant, r.idTerminal, r.item, r.address, r.contactPerson, r.serialKey));
  }


  onDataLoadFailed(error: any) {
    this._toastr.error( `Unable to retrieve users from the server`,"Load Error");
  }

  loadPosHistorysData() {
    // this.alertService.startLoadingMessage();
    this.loadingIndicator = true;
    this.bankportalservice.bankPortal_GetRetrievedHistory().subscribe(results => this.onDataLoadSuccessful(results), error => this.onDataLoadFailed(error));
  }
  onDataLoadSuccessful(posHistory: PosHistoryViewModel[]) {
    // this.alertService.stopLoadingMessage();
  
  }
  gridOptions = {
    rowSelection: 'multiple',
    enableSorting: 'true',
    enableColResize: 'true',
    enableRtl: 'true',
    pagination: 'true',
    paginationAutoPageSize: 'true',
    animateRows: 'true',
    rowClicked: 'true',
    enableCellTextSelection: 'true'
  }

  loadAccesoriesRequestDetails() {
    this.bankportalservice.bankPortal_GetSparesRequests().subscribe(res => {
        this.rows = res;
    },
     error => this.unSuccess(error));

  }
  unSuccess(error: any) {
    // this.notify.showError("Error", "Error !!");
  }

  public SpareRequestStatus (params:any){
    if (params.data.spareRequestStatus === 1) {
      return ('<span class="font-weight-bolder badge badge-info">PENDING</span>');
    }
    if (params.data.spareRequestStatus === 2) {
      return (`<span class="font-weight-bolder badge badge-warning"> PARTIALLY DELIVERED</span>`);
    }
    if (params.data.spareRequestStatus === 3) {
      return ('<span class="font-weight-bolder badge badge-primary">DELIVERED TO MERCHANT</span>')
    }
  }

}
